// Mock data for Sam Turner Fitness clone

export const IMAGES = {
  samHero: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/42hzklq9_3B6C4606-8F64-4713-AA59-E65393B2B164.webp',
  samMirror: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/u0gdr6by_1529E4AC-76A5-4F82-9066-22CC3570E08C.JPG',
  groupLycan: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/3s0wp74a_B7ED269A-20B7-4EDB-9775-12524E159B08.JPG',
  warrior: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/5qf5k7g2_9654A8E7-044E-4E02-A660-8E4574388E7D.JPG',
  mumBaby: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/rduqrhi2_90FA9DC0-AB8F-407E-9D35-EBDDA95DE6B0.webp',
  mumBaby2: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/cjqljdgc_1C782DAA-85A7-4E73-85F5-C211F2777D01.JPG',
  aboutFamily: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/m0wvdsn5_2.png',
  aboutOutdoors: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/rv4fcmvp_5.png',
  hero: 'https://images.unsplash.com/photo-1648542036561-e1d66a5ae2b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxmZW1hbGUlMjBwZXJzb25hbCUyMHRyYWluZXJ8ZW58MHx8fHwxNzg3NzEyOTE5fDA&ixlib=rb-4.1.0&q=85',
  pt1: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxmZW1hbGUlMjBwZXJzb25hbCUyMHRyYWluZXJ8ZW58MHx8fHwxNzg3NzEyOTE5fDA&ixlib=rb-4.1.0&q=85',
  pt2: 'https://images.unsplash.com/photo-1548690312-e3b507d8c110?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxmZW1hbGUlMjBwZXJzb25hbCUyMHRyYWluZXJ8ZW58MHx8fHwxNzg3NzEyOTE5fDA&ixlib=rb-4.1.0&q=85',
  ptCoach: 'https://images.pexels.com/photos/6922159/pexels-photo-6922159.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  group1: 'https://images.unsplash.com/photo-1554284126-aa88f22d8b74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxncm91cCUyMGZpdG5lc3MlMjBjbGFzc3xlbnwwfHx8fDE3ODc3MTI5MTl8MA&ixlib=rb-4.1.0&q=85',
  group2: 'https://images.unsplash.com/photo-1517130038641-a774d04afb3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxncm91cCUyMGZpdG5lc3MlMjBjbGFzc3xlbnwwfHx8fDE3ODc3MTI5MTl8MA&ixlib=rb-4.1.0&q=85',
  nutrition1: 'https://images.unsplash.com/photo-1543352632-5a4b24e4d2a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxtZWFsJTIwcHJlcHxlbnwwfHx8fDE3ODc3MTI5MTl8MA&ixlib=rb-4.1.0&q=85',
  nutrition2: 'https://images.pexels.com/photos/4929677/pexels-photo-4929677.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  nutrition3: 'https://images.pexels.com/photos/12050951/pexels-photo-12050951.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
};

export const services = [
  {
    slug: 'personal-training',
    title: 'Personal Training',
    img: IMAGES.samMirror,
    desc: 'Working face to face on a personalised program for you. Motivating, guiding and supporting you all the way. Weekly check-ins & accountability included.',
    tags: ['1-2-1', 'Custom Program', 'Weekly Check-ins'],
    longDesc: "Face to face personal session, programme built towards goals with nutritional advice designed around current lifestyle. Results aren't given, they are earnt and I am here every step of the way to guide, challenge and support you. My coaching isn't just about the physical change, it's about proving to yourself that you CAN do the hard things, bringing out the best in my clients, showing them that changes in lifestyle will always win.",
    highlights: [
      'Personalised 8-12 week training block',
      'Weekly check-ins and progress tracking',
      'Optional nutrition guidance layered on top',
      'Book in blocks of 12 or 24 sessions',
    ],
    fromPrice: 'From £30/hour',
    ideal: 'Perfect for people who want a coach in their corner and results they can measure.',
    results: [
      { img: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/egaf8q8e_659E94D2-9E0A-4A91-A41F-EAAAA2FF447D.webp', caption: 'Strength, definition & confidence rebuilt' },
      { img: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/ivvclier_A8E9A22B-89E1-4177-AB7E-F81DBD1E79A6.webp', caption: 'Leaner, stronger, back in control' },
    ],
  },
  {
    slug: 'group-fitness',
    title: 'Group Fitness',
    img: IMAGES.mumBaby,
    desc: 'Train together in a supportive group, focusing on getting stronger. Sessions are designed to challenge you with optional weekly check-ins and nutrition support.',
    tags: ['Strength Circuits', 'HIIT Spinning', 'Conditioning'],
    longDesc: 'A packed weekly timetable of strength circuits, HIIT spinning and conditioning sessions at ST Fitness. Great music, a supportive crew, and every rep can be scaled from beginner to advanced.',
    highlights: [
      'Up to 4 sessions per week on a monthly pass',
      'Strength circuits, HIIT spinning and conditioning',
      'Every workout scales to your level',
      'Community WhatsApp group and monthly socials',
      'Drop-in classes available at £6',
    ],
    fromPrice: '£6 PAYG',
    ideal: 'Perfect for anyone who trains better with people around them.',
    community: {
      heading: 'Hikes, races &',
      accent: 'good people',
      tagline: 'Hikes, fun competitions and days out surrounded by supportive people who have got your back.',
      photos: [
        { src: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/fetvb64m_5c3b478e88e6daa3fbe5a00c901b5287.webp', alt: 'ST Fitness team completing Total Warrior', label: 'Total Warrior · Team ST' },
        { src: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/jk5eed1r_IMG_0159.webp', alt: 'ST Fitness hike at the summit', label: 'Peak District · Summit crew' },
        { src: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/oyak63os_IMG_1238.webp', alt: 'ST Fitness team in pink at race start', label: 'Pretty Muddy · Team ST' },
        { src: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/iubkjg5x_cdf57ae3cc67325ec693bce43f3661e5.jpeg', alt: 'Finish line sprint together', label: 'Finish line · Together' },
        { src: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/q51wvdts_702b86e0-86c0-4074-aa5b-b245367eb66a.jpg', alt: 'Farmer Strong outdoor session', label: 'Farmer Strong' },
      ],
    },
  },
  {
    slug: 'mum-and-baby',
    title: 'Mum & Baby',
    img: IMAGES.groupLycan,
    desc: 'Postnatal-safe sessions where mums rebuild strength with their little ones alongside them. A welcoming community and a coach who gets it.',
    tags: ['Postnatal', 'Baby Welcome', 'Community'],
    longDesc: "Postnatal-safe classes where mums rebuild core, glute and posture strength while their little ones are welcome alongside them. Zero pressure, huge support, and a coach who's been there.",
    highlights: [
      'Train in a safe environment',
      'Child friendly, always welcome',
      'Weekly check-ins',
      'Accountability',
      'Community',
    ],
    fromPrice: 'From £6 per class',
    ideal: 'Perfect for new mums easing back into training safely.',
    testimonials: [
      {
        img: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/pupx2twd_d07bb59a-f383-486b-92ec-11ddb5064f0e.webp',
        stat: '-71',
        statUnit: 'LBS',
        stat2: '3+',
        stat2Unit: 'Years Coached',
        quote: "I can't recommend Sam enough. I have been training with her for over 3 years now and continued to make progress mentally and physically. The photo on the right is me in January 2017 and the left photo is me in August 2020. Sam also kept me sane during lockdown and helped me through PND with having some routine and structure to the day. I set small goals and had weekly check-ins. Advice and information was always available whenever I felt stuck or unmotivated. I am now at a 71LBS lost since starting with Sam. Going forward I can't wait to see what more I can do with Sam's help. I'm happier than ever, healthier than ever and I've had the best support I have needed every step of the way!",
        beforeDate: 'January 2017',
        afterDate: 'August 2020',
      },
    ],
  },
  {
    slug: 'online-coaching',
    title: 'Online Programme',
    img: IMAGES.samHero,
    desc: 'Online programme built around your week. Weekly check-in with me, not an app. Nutrition that works for the whole house. Train at home or wherever you are.',
    tags: ['Train Anywhere', 'Weekly Check-ins', 'Whole Family'],
    longDesc: "Fully personalised online coaching that fits around your week. Custom training plan delivered through your phone, weekly video review from me (not a bot), and nutrition that works for the whole house. It's a full package, training, nutritional support, accountability, mid week and weekly check-ins. All this built around and for YOU.",
    highlights: [
      'Fits around your lifestyle and ability',
      'Exclusive access to my fitness app',
      'Daily habit tracker to keep you on the right path',
      'Weekly check-ins to keep you accountable',
      'Nutritional advice that can work around your house',
    ],
    fromPrice: 'From £80/month',
    ideal: 'Perfect for people who want expert coaching without the studio commute.',
  },
];

export const transforms = [
  'Weekly timetable of group classes',
  '1-2-1 Personal Training',
  'Online coaching & training programmes',
  'Nutritional advice & weight management',
  'Mum & Baby classes',
];

export const packages = [
  {
    tag: 'PAY AS YOU GO',
    title: 'Drop-in Classes',
    price: '£6',
    unit: '/class',
    features: ['No commitment', 'Any class in the timetable', 'Great intro option', 'Bring a friend'],
    highlight: false,
  },
  {
    tag: 'MOST POPULAR',
    title: 'Group Fitness Pass',
    price: '£50',
    unit: '/month',
    features: ['Up to 4 sessions per week', 'Access to all group classes', 'Community WhatsApp group', 'Nutrition guide'],
    highlight: true,
  },
  {
    tag: '1-2-1 COACHING',
    title: 'Personal Training',
    price: '£30',
    unit: '/hour',
    features: ['Tailored program', 'Weekly check-ins', 'Form & technique focus', 'Progress tracking'],
    highlight: false,
  },
  {
    tag: 'ONLINE',
    title: 'Online Programme',
    price: '£80',
    unit: '/month',
    features: ['Custom training plan', 'App-based tracking', 'Weekly video review', 'Nutrition support'],
    highlight: false,
  },
];

export const testimonials = [
  {
    name: 'Natalie Prior',
    role: 'Mum & Baby Class',
    text: "I can't recommend Sam enough, she is a fantastic trainer. For any new mums out there definitely get to Sam's mum and baby classes, they are amazing. She is so passionate and supportive in helping us get back into shape. Her motivation and dedication is always 100%. It's a great atmosphere and there really is No Excuses!",
    rating: 5,
  },
  {
    name: 'Claire Mitchell',
    role: 'Group Fitness',
    text: "I love attending Sam's classes. She instantly put me at ease and made me feel welcome. During the classes she explains everything in detail and watches to ensure the correct techniques. Sam is enthusiastic and highly motivating.",
    rating: 5,
  },
  {
    name: 'Anna Goddard',
    role: '1-2-1 Personal Training',
    text: "Going back to the gym after baby number 2 was daunting. Sam was FANTASTIC, she got me and knew I liked to be pushed. If you want to lose weight, tone up and get fit in a healthy, fun and achievable way, Sam is your PT. Don't think about contacting her.... DO IT!",
    rating: 5,
  },
  {
    name: 'James Rowley',
    role: 'Online Coaching',
    text: "Sam's online programme is a game changer. The check-ins keep me accountable and the plans are properly tailored, not copy paste. Down 12kg and feeling stronger than ever.",
    rating: 5,
  },
];

export const moreTransformations = [
  'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/crs8rk66_C7FC3405-04C9-40C9-952B-3459C502C499.webp',
  'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/cd9zmirx_6562924B-2FDA-45E8-A5DC-E66CC67A6B4A.webp',
  'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/9zfhfcm2_8C17392A-9141-46EC-98E8-483905CBD1DC.webp',
  'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/qvlm80q0_8BAD2CF4-A647-45FA-84A1-A0CAC379BE70.webp',
  'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/bzm50k96_5D488BCB-4123-4D71-A7C3-2EC5873255FC.webp',
  'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/y1mskzm9_IMG_4150.JPG',
  'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/x6bca9h7_IMG_4025.JPG',
  'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/f9mg341f_E756E2FE-0E25-4DFD-B741-192474DAC350.webp',
  'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/k747mgrx_e9b3124c-2ceb-4fdc-9c41-8000868f86a9.jpg',
  'https://customer-assets-lxgj4vgw.emergentagent.net/job_strength-success-hub/artifacts/sdgq1oaw_DCC0AB9A-EF9A-44C4-B173-541532CD8D08.webp',
];

const withIds = (day, slots) => slots.map((s) => ({ ...s, slotId: `${day}-${s.time}` }));

export const CLASS_CAPACITY = 20;

export const timetable = [
  { day: 'Monday', slots: withIds('Monday', [
    { time: '18:00', name: 'Weighted Circuits', level: 'All Levels' },
  ]) },
  { day: 'Wednesday', slots: withIds('Wednesday', [
    { time: '10:00', name: 'Lower Body & Core', level: 'All Levels', private: true, note: 'Private block booking only' },
    { time: '17:50', name: 'Spinning', level: 'All Levels', capacity: 9 },
  ]) },
  { day: 'Thursday', slots: withIds('Thursday', [
    { time: '09:15', name: 'Spinning', level: 'All Levels', capacity: 9 },
    { time: '18:15', name: 'Weights & Ergs', level: 'Intermediate' },
  ]) },
  { day: 'Friday', slots: withIds('Friday', [
    { time: '09:15', name: 'Strength Circuits', level: 'All Levels' },
  ]) },
];

export const timetablePricing = { dropIn: '£6', monthly: '£40', tag: 'Small Groups · Kids Welcome' };

// Before/After transformation pairs (mock, using different crops as stand-ins)
export const beforeAfters = [
  { name: 'Emma T.', months: 4, lost: '11kg', before: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=900&q=80', after: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=900&q=80' },
  { name: 'Sarah L.', months: 6, lost: '15kg', before: 'https://images.unsplash.com/photo-1550345332-09e3ac987658?w=900&q=80', after: 'https://images.unsplash.com/photo-1548690312-e3b507d8c110?w=900&q=80' },
  { name: 'Rachel B.', months: 3, lost: '7kg', before: 'https://images.unsplash.com/photo-1487956382158-bb926046304a?w=900&q=80', after: 'https://images.unsplash.com/photo-1594381898411-846e7d193883?w=900&q=80' },
];

export const results = [
  { name: 'Emma T.', months: 4, lost: '11kg', img: IMAGES.pt2, quote: 'From tired mum to strong and confident.' },
  { name: 'Sarah L.', months: 6, lost: '15kg', img: IMAGES.group2, quote: 'Best decision I ever made for myself.' },
  { name: 'Rachel B.', months: 3, lost: '7kg', img: IMAGES.ptCoach, quote: 'Sam changed my whole relationship with fitness.' },
  { name: 'Jenna K.', months: 5, lost: '9kg', img: IMAGES.nutrition2, quote: 'The nutrition plan finally clicked for me.' },
];

export const offerings = [
  { icon: 'user', title: 'Personal Training', desc: '1-2-1 sessions tailored to you' },
  { icon: 'laptop', title: 'Online Programme', desc: 'Train anywhere, weekly check-ins' },
  { icon: 'users', title: 'Group Sessions', desc: 'Strength & metcon in a crew' },
  { icon: 'baby', title: 'Mum & Baby', desc: 'Postnatal-safe group classes' },
];

export const faq = [
  { q: 'Do I need to be fit to start?', a: 'Not at all. Every session can be scaled to your current level. We meet you where you are and progress from there.' },
  { q: 'Where are the classes held?', a: 'ST Fitness, inside Lycan Strength, Unit 2, Oasis Business Centre, Irlam, Manchester M44 5BL.' },
  { q: 'Can I try before I commit?', a: 'Yes, book a drop-in for £6 and try any class in the timetable before committing to a pass.' },
  { q: 'Do you offer online coaching?', a: 'Absolutely. Our online programme includes a custom plan, app-based tracking and weekly video review.' },
  { q: 'Is there parking?', a: 'Free onsite parking is available for all members.' },
  { q: 'What should I bring to my first class?', a: 'Trainers, a water bottle and a towel. We provide everything else, mats, weights, resistance bands and a strong playlist.' },
  { q: 'How soon will I see results?', a: 'Most clients feel stronger and sleep better within 2 weeks. Visible body composition change typically lands between weeks 6–10 with consistent training and nutrition.' },
  { q: 'Can I freeze or cancel my pass?', a: 'You can freeze a monthly pass for up to 4 weeks. Cancel anytime with 14 days notice, no auto-renewal traps.' },
  { q: 'Do you write bespoke nutrition plans?', a: 'Yes. After a confidential consultation form, I build a plan around your preferences, allergies, schedule and goals.' },
];

// Structured FAQ for the dedicated /faq page
export const faqCategories = [
  {
    title: 'Getting Started',
    items: [
      { q: 'Do I need to be fit to start?', a: 'Not at all. Every session can be scaled to your current level. We meet you where you are and progress from there.' },
      { q: 'Can I try before I commit?', a: 'Yes, book a drop-in for £6 and try any class in the timetable before committing to a pass.' },
      { q: 'What should I bring to my first class?', a: 'Trainers, a water bottle and a towel. We provide everything else, mats, weights, resistance bands and a strong playlist.' },
      { q: 'What is your intro offer for new clients?', a: "First class is on the house. Book a drop-in and I'll refund it if you decide to sign up for a monthly pass in the same week." },
      { q: 'How do I book my first session?', a: 'Head to the Transform page, tap any slot and reserve. You will get an instant confirmation and I will follow up with what to expect.' },
    ],
  },
  {
    title: 'Training & Programmes',
    items: [
      { q: 'How soon will I see results?', a: 'Most clients feel stronger and sleep better within 2 weeks. Visible body composition change typically lands between weeks 6–10 with consistent training and nutrition.' },
      { q: 'Do you write bespoke nutrition plans?', a: 'Yes. After a confidential consultation form, I build a plan around your preferences, allergies, schedule and goals.' },
      { q: 'Can I do 1-2-1 and group at the same time?', a: 'Yes, many clients pair a weekly 1-2-1 with 2 group sessions for balance, technique work and motivation.' },
      { q: 'How is the online programme delivered?', a: 'You get an app-based training plan, a personalised nutrition guide and a weekly video review from me. Direct messaging is included.' },
      { q: 'Can I train around an injury?', a: 'Absolutely. Send over the details on your intake form and I will design safe scaling and mobility work around it.' },
    ],
  },
  {
    title: 'Membership & Payments',
    items: [
      { q: 'Can I freeze or cancel my pass?', a: 'You can freeze a monthly pass for up to 4 weeks. Cancel anytime with 14 days notice, no auto-renewal traps.' },
      { q: 'How do payments work?', a: 'Pay-as-you-go by card at the studio, or monthly by direct debit for passes. Online coaching is billed monthly in advance.' },
      { q: 'Do you offer a family discount?', a: 'Yes, two people from the same household get 15% off any monthly pass. Just mention it on your enquiry.' },
      { q: 'Are there refunds if I cannot attend a class I booked?', a: 'Cancel a class booking up to 4 hours in advance and I will move your credit to another slot. No shows without notice cannot be refunded.' },
    ],
  },
  {
    title: 'The Studio',
    items: [
      { q: 'Where are the classes held?', a: 'ST Fitness, inside Lycan Strength, Unit 2, Oasis Business Centre, Irlam, Manchester M44 5BL.' },
      { q: 'Is there parking?', a: 'Free onsite parking is available for all members.' },
      { q: 'Are showers and changing rooms available?', a: 'Yes, separate changing rooms with showers, lockers and hair dryers.' },
      { q: 'Is the studio accessible?', a: 'Ground floor access, wide doorways and accessible facilities are all in place. Message me before your first visit and I will meet you at the door.' },
    ],
  },
];
